// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue';
import Resource from 'vue-resource';
import VeeValidate from 'vee-validate';
import VueFlashMessage from 'vue-flash-message';
import App from './App';
import router from './router';
import Mixins from './mixins/mixins';
import PDFMixins from './mixins/pdf_mixins';
import { store } from './store/store';
import './assets/style.scss';

// require('vue-flash-message/dist/vue-flash-message.min.css');

Vue.use(Resource);
Vue.use(VeeValidate);
Vue.mixin(Mixins);
Vue.mixin(PDFMixins);

Vue.use(VueFlashMessage);

router.beforeEach((to, from, next) => {
  document.title = to.meta.title;
  next();
});

Vue.config.productionTip                = false;
Vue.http.headers.common['X-CSRF-TOKEN'] = 'HancocksHalfHour';
Vue.http.options.root                   = (process.env.NODE_ENV === 'production' ? 'https://demo-api.rawmadesimple.co.uk' : 'http://localhost:4000');
// Vue.http.options.root                   = 'https://api.rawmadesimple.co.uk';

// http://178.62.47.184:4000

Vue.http.interceptors.push((req, next) => {
  if(!req.url.includes('http')){
    req.url = 'v1/'+ req.url; // Prepend API version number
  }
  if(req.headers.get("override-security-token")){
    req.headers.set('x-security-token', req.headers.get("override-security-token")); // Set security token header
    req.headers.set('Authorization', 'Bearer ' + req.headers.get("override-security-token")); // Set security token header
  } else {
    req.headers.set('x-security-token', store.getters.auth_key); // Set security token header
    req.headers.set('Authorization', 'Bearer '+ store.getters.auth_key); // Set security token header
  }
  next((res) => {
    if(res.status === 401){ // Check to make sure the response was good, log out if not
      store.commit('logOut');
      router.push('/login');
    }
  });
});

new Vue({
  router,
  store,
  el         : '#app',
  template   : '<App/>',
  components : { App }
});



// WEBPACK FOOTER //
// ./src/main.js